// extracted by mini-css-extract-plugin
export default {"form":"Form_form__e1yzW","group":"Form_group__2K1UB","error":"Form_error__Roa6G"};